import React from 'react';
import { ActiveLink } from '../../../ActiveLink';
import { ArticleCategoriesLinks } from './ArticleCategoriesLinks';

export const ArticlesSections = ({ menuSync }) => {
  return (
    <ActiveLink>
      {({ isActive }) => (
        <ArticleCategoriesLinks
          validateActiveLink={isActive}
          menuSync={menuSync}
        />
      )}
    </ActiveLink>
  );
};
